import { registerEventHandler } from './RegisterEventHandler.js';

var resizeCallbacks = [];
var ratioCallbacks = [];
var viewportCallbacks = [];
var viewport;
var eventHandler;
var initialViewportSize;
/** Method for getting the viewport size change. Use `getInitialViewportSize` if the component is not hydrated */

var getViewportSize = function getViewportSize() {
  if (typeof document === "undefined") {
    return initialViewportSize || "xs";
  }

  return document.body && window.getComputedStyle(document.body, ":after").content.replace(/["']/g, "");
};
/** Method for setting the viewport size inside the constructor or before the component is hydrated into the DOM */


var setInitialViewportSize = function setInitialViewportSize(v) {
  return initialViewportSize = v;
};
/** Method for getting the viewport size inside the constructor or before the component is hydrated into the DOM */


var getInitialViewportSize = function getInitialViewportSize() {
  return initialViewportSize || "xs";
};

var runCallbacks = function runCallbacks() {
  eventHandler.unsetRunning();
  var newViewport = getViewportSize();

  if (viewport !== newViewport) {
    viewport = newViewport;
    viewportCallbacks.forEach(function (callback) {
      // make sure, that meanwhile, the callback has not been removed from the list.
      if (viewportCallbacks.includes(callback)) {
        callback(newViewport);
      }
    });
  }

  var ratio = window.innerWidth / window.innerHeight;
  resizeCallbacks.forEach(function (callback) {
    // make sure, that meanwhile, the callback has not been removed from the list.
    if (resizeCallbacks.includes(callback)) {
      callback();
    }
  });
  ratioCallbacks.forEach(function (callbackObject) {
    // make sure, that meanwhile, the callbackObject has not been removed from the list.
    if (ratioCallbacks.includes(callbackObject)) {
      var minRatio = callbackObject.minRatio,
          lastResult = callbackObject.lastResult,
          callback = callbackObject.callback;
      var currentResult = ratio >= minRatio;

      if (currentResult !== lastResult) {
        callback(currentResult); // eslint-disable-next-line no-param-reassign

        callbackObject.lastResult = currentResult;
      }
    }
  });
};

var tryRegisterHandler = function tryRegisterHandler() {
  eventHandler = eventHandler || registerEventHandler("resize", runCallbacks);
  viewport = viewport || getViewportSize();
};

var tryUnregisterHandler = function tryUnregisterHandler() {
  if (!resizeCallbacks.length && !ratioCallbacks.length && !viewportCallbacks.length && eventHandler) {
    eventHandler.unsubscribe();
    eventHandler = undefined;
  }
};

var addResizeCallback = function addResizeCallback(callback) {
  tryRegisterHandler();
  resizeCallbacks.push(callback);
  callback();
};

var addViewportCallback = function addViewportCallback(callback) {
  tryRegisterHandler();
  viewportCallbacks.push(callback);
  callback(getViewportSize());
};

var removeResizeCallback = function removeResizeCallback(callback) {
  resizeCallbacks = resizeCallbacks.filter(function (c) {
    return c !== callback;
  });
  tryUnregisterHandler();
};

var removeViewportCallback = function removeViewportCallback(callback) {
  viewportCallbacks = viewportCallbacks.filter(function (c) {
    return c !== callback;
  });
  tryUnregisterHandler();
};

export { addResizeCallback, addViewportCallback, getInitialViewportSize, getViewportSize, removeResizeCallback, removeViewportCallback, setInitialViewportSize };
